module.exports = __webpack_public_path__ + "img/[抱拳].db168a62.svg";